import React, { createContext, useState, useContext, useEffect } from 'react';
import englishTranslations from '../lang/eng.json';
import malayTranslations from '../lang/ms.json';

const LanguageContext = createContext();

export const languages = {
  ENGLISH: 'en',
  MALAY: 'ms'
};

const languageData = {
  [languages.ENGLISH]: englishTranslations,
  [languages.MALAY]: malayTranslations
};

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState(() => {
    const savedLanguage = localStorage.getItem('language');
    return savedLanguage || languages.ENGLISH;
  });

  useEffect(() => {
    localStorage.setItem('language', language);
  }, [language]);

  const changeLanguage = (lang) => {
    if (Object.values(languages).includes(lang)) {
      setLanguage(lang);
    }
  };

  const translations = languageData[language] || languageData[languages.ENGLISH];

  const value = {
    language,
    changeLanguage,
    translations,
    languages
  };

  return (
    <LanguageContext.Provider value={value}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};